import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableHeader,
  TableHeaderCell,
  TableHeaderRow,
  TableRow,
  Text,
} from '@razorpay/blade/components';
import { SalaryStructureComponent } from 'components/SalaryStructure/types';
import React from 'react';
import { getSalaryStructureComponentFormulas } from '../utils';

const StructureComponentTable = ({ components }: { components: SalaryStructureComponent[] }) => {
  return (
    <Box borderRadius={'large'} overflow={'clip'}>
      <Table
        rowDensity="compact"
        backgroundColor="transparent"
        data={{
          nodes: components,
        }}>
        {(tableData) => {
          return (
            <>
              <TableHeader>
                <TableHeaderRow>
                  <TableHeaderCell textAlign="left">
                    <Text weight="semibold">Component</Text>
                  </TableHeaderCell>
                  <TableHeaderCell textAlign="right">
                    <Text weight="semibold">Calculation</Text>
                  </TableHeaderCell>
                </TableHeaderRow>
              </TableHeader>
              <TableBody>
                {tableData.map((item) => {
                  return (
                    <TableRow key={item.id} item={item}>
                      <TableCell>
                        {item.salaryComponent.settings.behaviour.displayBehaviour?.displayName ??
                          item.salaryComponent.name}
                      </TableCell>
                      <TableCell textAlign="right">
                        <Text color="surface.text.gray.muted" variant="body">
                          {getSalaryStructureComponentFormulas(item)}
                        </Text>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </>
          );
        }}
      </Table>
    </Box>
  );
};

export default StructureComponentTable;
